import { Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    tableCell: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    }
}));

function TableTooltip(props){
    const {value} = props

    const classes = useStyles()

    return (
        <Tooltip title={value}>
            <span className={classes.tableCell}>{value}</span>
        </Tooltip>
    )
}

export default TableTooltip